import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';

import App from './App';
import { CookiesProvider } from 'react-cookie';
import configureStore from './redux/store';
import { syncNocookiesFromUrl, hasNocookiesOptOut } from './extensions/utils';

import HttpsRedirect from 'react-https-redirect';

import './index.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const { store, persistor } = configureStore();

syncNocookiesFromUrl();
const skipCookiesProvider = hasNocookiesOptOut();

const appInner = (
    <ConfigProvider
        theme={{
            token: {
                fontFamily: 'Roboto, sans-serif',
                fontSize: 16,
                Button: {
                    fontSize: 16,
                },
                Card: {
                    bodyPadding: 9,
                },
            },
        }}
    >
        <HttpsRedirect>
            <App />
        </HttpsRedirect>
    </ConfigProvider>
);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter basename={baseUrl}>
                {skipCookiesProvider ? appInner : <CookiesProvider>{appInner}</CookiesProvider>}
            </BrowserRouter>
        </PersistGate>
    </Provider>,
    rootElement
);
